export default __webpack_public_path__ + "static/media/ic_my_location.56c67432.svg";